import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9d2b4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt padding" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "bread padding" }
const _hoisted_6 = { class: "bd" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公司介绍", -1))
const _hoisted_10 = { class: "ins-nav-box" }
const _hoisted_11 = { class: "ins-nav" }
const _hoisted_12 = { class: "case padding" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "c-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "items" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line gd" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.banner,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.parent.name), 1),
        _createElementVNode("h3", {
          innerHTML: _ctx.parent.text
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _hoisted_9
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: item.route,
            key: item.id,
            class: _normalizeClass(_ctx.route.path == item.route ? 'link active' : 'link')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.banner.name), 1),
          _hoisted_15,
          _createElementVNode("div", {
            class: "con",
            innerHTML: _ctx.banner.f_title
          }, null, 8, _hoisted_16)
        ]),
        _createElementVNode("div", {
          class: "desc",
          innerHTML: _ctx.banner.text
        }, null, 8, _hoisted_17)
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.List, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: { path: '/case-detail/' + item.id },
            class: "item",
            key: item.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.image,
                alt: "",
                class: "img"
              }, null, 8, _hoisted_19),
              _createElementVNode("h6", null, _toDisplayString(item.title), 1),
              _createElementVNode("div", {
                class: "desc",
                innerHTML: item.text
              }, null, 8, _hoisted_20),
              _hoisted_21
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}